export const Fallback = ({ name }) => (
  <div className="fallback">Loading {name}...</div>
);
